// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card___kYfa","content":"Card_content__24TUN","error":"Card_error__kjVn-","success":"Card_success__3vj_C","warning":"Card_warning__xXZyM","info":"Card_info__TTTdI"};